const napoChannels = [
  'www.delfi.lt/gyvenimas',
  'www.delfi.lt/grynas',
  'www.delfi.lt/kablys',
  'www.delfi.lt/keliones',
  'www.delfi.lt/kultura',
  'www.delfi.lt/letena',
  'www.delfi.lt/maistas',
  'www.delfi.lt/moterys',
  'www.delfi.lt/seima',
  'www.delfi.lt/stilius',
];

export default function hasNapoComments(article: any) {
  return napoChannels.includes(article.primaryCategory.channel.url);
}
